import { LandingContent } from "./types";

export const serviceLineLanding: LandingContent = {
  ctaText: "Schedule a walkthrough",
  quickFacts: [
    "2–4 week implementation",
    "$0 setup fee",
    "Built for the trades",
  ],
  whyHeading: "Why teams use ServiceLine",
  why: "ServiceLine is the field service platform built by CertainPath members for CertainPath members. We kept the features that drive revenue — call booking, dispatch, mobile tech app, memberships, invoicing — and removed the bloat that turned into a second full-time job to administer. Implementation in weeks, not months.",
  advantages: [
    {
      title: "Unified customer record",
      description:
        "Calls, jobs, invoices, notes, and marketing history on one timeline. No tab-switching.",
      includedNote: "Implementation in 2-4 weeks",
    },
    {
      title: "Dispatch board",
      description:
        "Drag-and-drop scheduling with capacity, skill, and geography constraints factored in.",
      includedNote: "Unified customer timeline",
    },
    {
      title: "Mobile technician app",
      description:
        "Offline-capable, voice-to-text notes, and a good-better-best presenter that techs actually want to use.",
      includedNote: "Mobile-first technician experience",
    },
  ],
  featureChecklist: [
    "Implementation in 2-4 weeks",
    "Unified customer timeline",
    "Mobile-first technician experience",
    "Membership engine built-in",
  ],
  highlights: [
    {
      title: "Memberships",
      description:
        "Full membership lifecycle — sign-up, recurring billing, renewal risk scoring, and cancellation flows.",
    },
    {
      title: "Invoicing & payments",
      description:
        "Mobile invoicing with card, ACH, and financing links. Syncs to QuickBooks nightly.",
    },
    {
      title: "Customer booking portal",
      description:
        "A branded self-service booking experience that reads your real dispatch board — no more 'we'll call to confirm'.",
    },
  ],
  steps: [
    {
      title: "Discovery & migration plan",
      description:
        "We map your current systems and customer data, then design a clean migration plan with zero downtime.",
    },
    {
      title: "2–4 week implementation",
      description:
        "Data migration, dispatch board configuration, and integration setup — handled by our team in weeks, not months.",
    },
    {
      title: "Team onboarding",
      description:
        "Office staff and technicians trained in the first week of go-live. Most teams are productive on day one.",
    },
    {
      title: "Ongoing partnership",
      description:
        "Quarterly business reviews, free product training for new hires, and a dedicated success manager.",
    },
  ],
  testimonials: [],
  faqs: [
    {
      question: "How does migration from my current software work?",
      answer:
        "We migrate customer records, history, memberships, and open jobs. The handoff is planned to your slow season, with parallel-running available if needed.",
    },
    {
      question: "Will my technicians actually use it?",
      answer:
        "Yes — that's the entire design goal. Big buttons, voice-to-text, offline-first, and an options presenter techs prefer over the legacy alternatives.",
    },
    {
      question: "What integrations are included?",
      answer:
        "QuickBooks, major call-tracking providers, and the rest of the CertainPath stack ship out of the box. Custom integrations available.",
    },
    {
      question: "Is there a long-term contract?",
      answer:
        "Month-to-month after a short initial term. We're confident in the platform — we don't lock you in.",
    },
  ],
  closing: {
    heading: "Run your business on ServiceLine",
    body: "Book a 30-minute walkthrough — we'll show you exactly how ServiceLine fits your operation and what migration looks like.",
  },
};
